import React from "react";

const VideoOnlineIcon = ({ size = 18, color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M6 15C6.82875 15 7.5 15.6713 7.5 16.5C7.5 17.3288 6.82875 18 6 18C5.17125 18 4.5 17.3288 4.5 16.5C4.5 15.6713 5.17125 15 6 15ZM7.77 4.90275C7.629 4.8315 7.47 4.90725 7.461 5.085V8.41575C7.47825 8.592 7.608 8.6685 7.77 8.598L10.7677 6.93225C10.9178 6.82875 10.9178 6.67125 10.7677 6.5685L7.77 4.90275ZM18 3.75V9.75C18 11.8177 16.3177 13.5 14.25 13.5H3.75C1.68225 13.5 0 11.8177 0 9.75V3.75C0 1.68225 1.68225 0 3.75 0H14.25C16.3177 0 18 1.68225 18 3.75ZM12.375 6.75C12.375 6.1305 12.0382 5.55825 11.4967 5.25675L8.499 3.591C7.416 2.94075 5.919 3.82125 5.961 5.08425V8.415C5.91825 9.678 7.416 10.5578 8.499 9.90825L11.4975 8.2425C12.039 7.941 12.3757 7.36875 12.3757 6.74925L12.375 6.75ZM18 16.5C18 16.0853 17.664 15.75 17.25 15.75H9.75C9.336 15.75 9 16.0853 9 16.5C9 16.9147 9.336 17.25 9.75 17.25H17.25C17.664 17.25 18 16.9147 18 16.5ZM3 16.5C3 16.0853 2.664 15.75 2.25 15.75H0.75C0.336 15.75 0 16.0853 0 16.5C0 16.9147 0.336 17.25 0.75 17.25H2.25C2.664 17.25 3 16.9147 3 16.5Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default VideoOnlineIcon;
